export default [
  {
    name: 'messageManages',
    path: 'messageManages',
    component: () =>
      import(/* webpackChunkName: "messageManages" */ './MessageList.vue')
  }
]
